// extracted by mini-css-extract-plugin
export var button = "_5j-7";
export var buttonRow = "_5j-6";
export var fadeIn = "_5j-1";
export var gradient = "_5j-0";
export var panel = "_5j-2";
export var panelIn = "_5j-3";
export var subtitle = "_5j-5";
export var title = "_5j-4";